import { render, staticRenderFns } from "./ProspectDetails.vue?vue&type=template&id=5b50a6b5&scoped=true"
import script from "./ProspectDetails.vue?vue&type=script&lang=ts"
export * from "./ProspectDetails.vue?vue&type=script&lang=ts"
import style0 from "./ProspectDetails.vue?vue&type=style&index=0&id=5b50a6b5&prod&scoped=true&lang=css"
import style1 from "./ProspectDetails.vue?vue&type=style&index=1&id=5b50a6b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b50a6b5",
  null
  
)

export default component.exports